module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/PE-03fd1a3021d42a15260c2ba4db002dbd.png";